import { TCountryCode, countries, getEmojiFlag } from 'countries-list';

export const countryCodes = Object.keys(countries);

export const getCountryLabel = (option?: string | null): string => {
  if (!option) return '';
  const code = option as TCountryCode;
  const country = countries[code];
  if (!country) return String(option);
  return [getEmojiFlag(code), country.name].join(' ').trim();
};

export const getCountryFlag = (code: string): string => {
  return getEmojiFlag(code as TCountryCode);
};
